import { newestSkills, nextSkills, type SkillLevels } from '@hazel/shared'

import { Card } from '../components/Card.js'

/** "the 7 times table and dividing by 3", rather than a bulleted list of two. */
function listOut(things: readonly string[]): string {
  if (things.length <= 1) return things[0] ?? ''
  return `${things.slice(0, -1).join(', ')} and ${things[things.length - 1]}`
}

/**
 * The one real sense of progression left.
 *
 * There are no scores, so nothing here is a number going up. What this says is
 * that the questions have changed — harder ones arrive because the easier ones
 * stopped being hard — and that is worth saying out loud rather than leaving
 * her to notice.
 *
 * Nothing is compared to anybody and nothing can be lost. A skill that has
 * opened up stays open.
 */
export function WhereSheIsUpTo({ levels }: { levels: SkillLevels }) {
  const newest = newestSkills(levels)
  const next = nextSkills(levels)

  // Before the first maths round there is nothing true to say, and inventing
  // encouragement for someone who has not played is how an app starts lying.
  if (newest.length === 0) return null

  return (
    <Card>
      <h2 className="text-(length:--text-heading) mb-3">Where you&rsquo;re up to</h2>

      <p>{`You’re onto ${listOut(newest.map((skill) => skill.label.toLowerCase()))} now.`}</p>

      {next.length > 0 ? (
        // No number and no distance. She cannot see the level and could not
        // act on it; all this says is that there is more, which is true.
        <p className="text-ink-muted text-(length:--text-small) mt-2">
          {`Keep going and ${listOut(next.map((skill) => skill.label.toLowerCase()))} comes next.`}
        </p>
      ) : null}
    </Card>
  )
}
